export const contact = {
  phone: '07781 113434',
  phoneHref: 'tel:+447781113434',
  email: 'info@guernseycleaning.co.uk',
  hours: 'Mon–Sat 8am–6pm',
  hoursLong: 'Monday – Saturday, 8:00am – 6:00pm',
  location: 'Guernsey, Channel Islands',
}

export const navLinks = [
  { label: 'Services', href: '/services' },
  { label: 'Who We Help', href: '/#who-we-help' },
  { label: 'About Us', href: '/#why-us' },
  { label: 'Contact', href: '/#contact' },
]

export const highlights = [
  {
    icon: 'award',
    title: '10 Years Industry Experience',
    description:
      'Built on extensive cleaning industry expertise and strong property sector knowledge.',
  },
  {
    icon: 'building',
    title: 'Property Industry Expertise',
    description:
      'We understand the standards expected by estate agencies, landlords and developers.',
  },
  {
    icon: 'home',
    title: 'Commercial & Residential Services',
    description:
      'Supporting businesses, rental properties, holiday lets and homeowners.',
  },
  {
    icon: 'shield',
    title: 'Fully Insured & Reliable',
    description:
      'Professional service with attention to detail and consistent standards.',
  },
] as const

export const audiences = [
  {
    icon: 'briefcase',
    title: 'Offices & Businesses',
    description: 'Clean, healthy workspaces that make a great impression.',
  },
  {
    icon: 'keyRound',
    title: 'Estate Agencies',
    description:
      'Reliable cleaning and presentation services for smooth property handovers.',
  },
  {
    icon: 'home',
    title: 'Landlords',
    description: 'Helping you get properties rental-ready, every time.',
  },
  {
    icon: 'hardHat',
    title: 'Developers & Contractors',
    description: 'Professional cleans for new builds and refurbishment projects.',
  },
  {
    icon: 'bedDouble',
    title: 'Airbnb & Holiday Lets',
    description: 'Immaculate changeovers and 5-star guest experiences.',
  },
] as const

export const reasons = [
  {
    title: '10 Years Experience',
    description: 'Over a decade of delivering exceptional cleaning services.',
  },
  {
    title: 'Fully Insured',
    description: 'Complete peace of mind with comprehensive insurance cover.',
  },
  {
    title: 'Reliable & Professional',
    description: 'Punctual, trustworthy and committed to the highest standards.',
  },
  {
    title: 'Flexible Scheduling',
    description:
      'We work around you to minimise disruption and meet your deadlines.',
  },
  {
    title: 'Attention to Detail',
    description: "We don't just clean — we care about the details that matter.",
  },
  {
    title: 'Trusted by Property Professionals',
    description:
      'Proudly supporting estate agencies, landlords, developers and businesses.',
  },
]

export const propertyServices = [
  'End of tenancy cleaning',
  'Pre-tenancy preparation',
  'Deep cleans',
  'Property refreshes',
  'Painting & decorating',
  'Communal area cleaning',
  'Emergency cleans',
  'Holiday let support',
]

export const propertyPartners = [
  'Estate Agents',
  'Letting Agents',
  'Property Managers',
  'Landlords',
]

export const partnerPromises = [
  'Fast turnaround times',
  'Flexible scheduling',
  'Consistent standards',
  'Clear communication',
  'One point of contact',
  'Fully insured',
]

export const processSteps = [
  {
    title: 'Get in touch',
    description:
      'Tell us about the property, the deadline and what needs doing. Call, email or send us a message.',
  },
  {
    title: 'Free, no-obligation quote',
    description:
      'We confirm scope, timings and a clear price — no hidden extras and no pressure.',
  },
  {
    title: 'We clean to the brief',
    description:
      'A vetted, fully insured team arrives on time and works to an agreed checklist.',
  },
  {
    title: 'Final check & handover',
    description:
      'We walk the property, photograph the finish on request and confirm it is ready to hand over.',
  },
]

export const images = {
  logo: 'https://cdn.magicpatterns.com/uploads/xwAeeZrJiopGFgdo69gV58/GC_Logo.svg',
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/24c87300-fb5f-4029-a6ec-209d0a3fdf54.jpg',
  property:
    'https://cdn.magicpatterns.com/patterns/generated-images/c1a9c23f-385c-4b04-aee6-1d4cb40dc774.jpg',
  office:
    'https://cdn.magicpatterns.com/patterns/generated-images/5d3a5d11-ff1c-46b3-88b2-379cd496753c.jpg',
  cta: 'https://cdn.magicpatterns.com/patterns/generated-images/b7a5f5b4-b333-48eb-b793-187dcc84241f.jpg',
}
